import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonComponent } from "src/app/core/elements/button.component";
import { LogoutButtonComponent } from "src/app/core/elements/logout-button.component";

@Component({
  selector: "mr-notice-page[message]",
  template: `
    <section>
      <p>{{ message }}</p>
      @if (buttonText) {
        @if (link) {
          <a [href]="link">{{ buttonText }}</a>
        } @else {
          <mr-button size="large" (click)="buttonClick.emit()">
            {{ buttonText }}
          </mr-button>
        }
      }
    </section>
    <mr-logout-button></mr-logout-button>
  `,
  styleUrls: ["./notice-page.component.scss"],
  imports: [ButtonComponent, LogoutButtonComponent],
})
export class NoticePageComponent {
  @Input() public message!: string;
  @Input() public link?: string;
  @Input() public buttonText?: string;

  @Output() public readonly buttonClick = new EventEmitter<void>();
}
